"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showEntityImportDialog = void 0;
const DialogHelper_1 = require("@juvare/common-web-ui/DialogHelper");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const ImportProgress_1 = require("../components/ImportProgress");
const SelectFileArea_1 = require("../components/SelectFileArea");
function showEntityImportDialog(params) {
    (0, DialogHelper_1.showCustomDialog)({
        maxWidth: 'sm',
        fullWidth: true,
        content: (close, ariaLabelledBy, ariaDescribedBy) => (react_1.default.createElement(EntityImportDialogComponent, Object.assign({}, params, { close: close, ariaLabelledById: ariaLabelledBy, ariaDescribedById: ariaDescribedBy }))),
    });
}
exports.showEntityImportDialog = showEntityImportDialog;
const EntityImportDialogComponent = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const [file, setFile] = react_1.default.useState();
    const handleImport = (file) => {
        (0, DialogHelper_1.showCustomDialog)({
            content: (close, ariaLabelledBy, ariaDescribedBy) => (react_1.default.createElement(ImportProgress_1.ImportProgress, { entity: props.entity, file: file, options: props.options, close: close, ariaLabelledById: ariaLabelledBy, ariaDescribedById: ariaDescribedBy })),
            fullWidth: true,
            maxWidth: 'sm',
        });
        props.close();
    };
    const handleRemoveFile = () => {
        setFile(undefined);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.DialogTitle, { id: props.ariaLabelledById }, (_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.dialogTitle) !== null && _b !== void 0 ? _b : 'Import'),
        react_1.default.createElement(material_1.DialogContent, { id: props.ariaDescribedById },
            ((_c = props.options) === null || _c === void 0 ? void 0 : _c.additionalDialogContent) && react_1.default.createElement(material_1.Box, { pb: 2 }, (_d = props.options) === null || _d === void 0 ? void 0 : _d.additionalDialogContent),
            react_1.default.createElement(SelectFileArea_1.SelectFileArea, { fileTypeLabel: 'CSV file', fileInputAccept: '.csv', file: file, onSelectFile: setFile, onRemoveFile: handleRemoveFile }),
            ((_e = props.options) === null || _e === void 0 ? void 0 : _e.csvTemplate) && (react_1.default.createElement(material_1.Box, { pt: 1 },
                react_1.default.createElement(material_1.Typography, { variant: 'caption', sx: { color: JuvareTheme_1.themeColors.text.subtle } },
                    "Don't have the CSV template?\u00A0",
                    react_1.default.createElement(material_1.Link, { download: (_f = props.options.csvTemplateName) !== null && _f !== void 0 ? _f : 'template.csv', href: `data:application/octet-stream,${encodeURIComponent((_g = props.options) === null || _g === void 0 ? void 0 : _g.csvTemplate)}`, "data-test": 'template-link' }, "Download"))))),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => props.close(), "data-test": 'close-dialog-button' }, "Close"),
            file && (react_1.default.createElement(material_1.Button, { onClick: () => handleImport(file), "data-test": 'import-dialog-button' }, "Import")))));
};
